'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagTlAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.22869e-06 0C9.33334 0 18.6667 -5.22354e-05 28 5.54323e-06V20C18.6667 20 9.33333 20 0 20C0 13.3333 -4.01452e-05 6.66667 6.22869e-06 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.22869e-06 0L28 5.54323e-06V20H0L6.22869e-06 0Z",
          fill: "#FF323E"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.22869e-06 0L17.3333 10L0 20L6.22869e-06 0Z",
          fill: "#FFCC51"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.22869e-06 0L12 10L0 20L6.22869e-06 0Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.94392 10.8244L5.05964 12.7633L4.59781 10.6829L2.48049 10.4411L4.31639 9.35895L3.8921 7.27054L5.48858 8.68219L7.34367 7.63331L6.49445 9.58787L8.06524 11.028L5.94392 10.8244Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagTlAsset = forwardRef(FlagTlAsset);

export { VpFlagTlAsset as default };
